import React from 'react';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnEightMd } from './styles/Column.styled';
import {
  FilterBlock,
  FilterOption,
  UlFilterMenu,
  LiFilterMenu,
} from './styles/FilterTabBlock.styled';
import { Section } from './styles/SectionHeadline.styled';
import { getTranslationByKey } from '../helpers/translation-helper';
import { DWTCContext } from '../utils/context';

export default function ExperiencesFilterTabBar({
  data,
  selectedFilter,
  setSelectedFilter,
  setDistanceValue,
  dir,
}) {
  const { translations } = React.useContext(DWTCContext);

  return (
    <Section className="bg_grey">
      <Container>
        <Row className="no-gutters">
          <ColumnEightMd className="margin_auto padding-lr-zero">
            <FilterBlock>
              <h2 dir={dir}>{data.title}</h2>
              <FilterOption dir={dir} className="experiences-filter">
                <UlFilterMenu dir={dir}>
                  {data.filters.map((tabLabel) => (
                    <LiFilterMenu
                      className={selectedFilter === tabLabel ? 'tabs active' : 'tabs'}
                      onClick={() => {
                        setDistanceValue(15);
                        setSelectedFilter(tabLabel);
                      }}
                      dir={dir}
                    >
                      <a href="#0">{getTranslationByKey(translations, tabLabel)}</a>
                    </LiFilterMenu>
                  ))}
                </UlFilterMenu>
              </FilterOption>
            </FilterBlock>
          </ColumnEightMd>
        </Row>
      </Container>
    </Section>
  );
}
